import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from 'tss-react/mui';
import { ApScheduledStatus } from '../../../../../sic-lib/enums/ApScheduledStatus';
import { ApSchedulerContact } from '../../../../../sic-lib/types/ApSchedulerContact';
import { setEditContact } from '../../../../../store/communicator';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    itemError: {
        /* matches theme.palette.error.light as rgb, includes alpha */
        backgroundColor: 'rgba(239, 83, 80, 0.4)',
        '&.Mui-selected': {
            color: theme.palette.common.white,
            backgroundColor: 'rgba(239, 83, 80, 0.7)',
        },
        '&.MuiListItem-button:hover': {
            color: theme.palette.common.white,
            backgroundColor: 'rgba(239, 83, 80, 0.7)',
        },
    },
    itemSuccess: {
        /* matches theme.palette.success.light as rgb, includes alpha */
        backgroundColor: 'rgba(129, 199, 132, 0.4)',
        '&.Mui-selected': {
            backgroundColor: 'rgba(129, 199, 132, 0.7)',
        },
        '&.MuiListItem-button:hover': {
            backgroundColor: 'rgba(129, 199, 132, 0.7)',
        },
    },
}));

interface Props {
    contact: ApSchedulerContact;
}

export default function ApSchedulerListItemAssigned({ contact }: Props) {
    const dispatch = useAppDispatch();
    const { classes, cx } = useStyles();

    const editContactId = useAppSelector(state => {
        return state.communicator?.editContactId || null;
    });

    const handleSelect = () => {
        dispatch(setEditContact(contact.contactId));
    };

    const handleSchedule = () => {
        if (contact.sendStatus !== ApScheduledStatus.scheduled) {
            console.log('TODO !');
            //dispatch(requestSchedule((contact.actionPlan as ApPlan).planId));
        }
    };

    return (
        <ListItem
            button
            onClick={handleSelect}
            selected={editContactId === contact.contactId}
            className={cx(
                classes.root,
                contact.sendStatus === ApScheduledStatus.scheduleError && classes.itemError,
                contact.sendStatus === ApScheduledStatus.scheduled && classes.itemSuccess,
            )}
        >
            <ListItemIcon>
                {contact.sendStatus === ApScheduledStatus.notScheduled && <ScheduleIcon />}
                {contact.sendStatus === ApScheduledStatus.scheduleError && <ErrorOutlineIcon />}
                {contact.sendStatus === ApScheduledStatus.scheduled && <CheckCircleOutlineIcon />}
            </ListItemIcon>
            <ListItemText primary={contact.name} secondary={contact.sendStatus} />
            <ListItemSecondaryAction>
                <Tooltip title="Schedule">
                    <IconButton
                        disabled={contact.sendStatus === ApScheduledStatus.scheduled}
                        onClick={handleSchedule}
                        size="large"
                    >
                        <SendIcon />
                    </IconButton>
                </Tooltip>
            </ListItemSecondaryAction>
        </ListItem>
    );
}
